import { FacialAuthenticateContent } from '@facephi/inphinite-common';
import {
  IconName,
  IconSize,
  IconWeight,
  InphiniteThemeColors,
} from '@facephi/ui-react';

export type tInfo = StateIconInfo & {
  message: string;
  message_authentication?: string;
  size: IconSize;
  weight: IconWeight;
};

export type StateIconInfo = {
  iconName: IconName;
  iconColor: InphiniteThemeColors;
  backgroundColor: InphiniteThemeColors;
};

export type FilesOptionListInfo = {
  menuTitle: string;
  menuIcon?: IconName;
  menuIconLeft?: IconName;
  assetName: string;
  assetIcon?: IconName;
};

export type CustomDropdownAsset = {
  type: string;
  url: string;
  contentType: string;
  position: number;
};

export type FacialValidationState = FacialAuthenticateContent & {
  id: string;
};

export const infoFacial: { [key in string]: tInfo } = {
  match: {
    message: 'The person on the document and the selfie match',
    message_authentication: 'The person of the selfie match',
    iconName: 'Check',
    iconColor: 'success400',
    backgroundColor: 'success100',
    weight: 'fill',
    size: '48',
  },
  notMatch: {
    message: 'The person on the document and the selfie dont match',
    message_authentication: 'The person dont match',
    iconName: 'X',
    iconColor: 'error400',
    backgroundColor: 'error100',
    weight: 'fill',
    size: '48',
  },
  notAble: {
    message:
      'We have not been able to verify. The photo may have some reflection or low resolution.',
    message_authentication:
      'We have not been able to verify. The photo may have some reflection or low resolution.',
    iconName: 'WarningCircle',
    iconColor: 'warning400',
    backgroundColor: 'warning100',
    weight: 'light',
    size: '48',
  },
  authOK: {
    message: 'The register was successful',
    message_authentication: 'The register was successful',
    iconName: 'Check',
    iconColor: 'success400',
    backgroundColor: 'success100',
    weight: 'fill',
    size: '48',
  },
};

export const stateCardInfo: { [key in string]: StateIconInfo } = {
  success: {
    iconName: 'Check',
    iconColor: 'success400',
    backgroundColor: 'success100',
  },
  error: { iconName: 'X', iconColor: 'error400', backgroundColor: 'error100' },
};

export const infoVoice: { [key in string]: tInfo } = {
  success: {
    message: 'The voice recording and the register match',
    iconName: 'Check',
    iconColor: 'success400',
    backgroundColor: 'success100',
    weight: 'fill',
    size: '48',
  },
  error: {
    message: `The voice recording and the register don't match`,
    iconName: 'X',
    iconColor: 'error400',
    backgroundColor: 'error100',
    weight: 'fill',
    size: '48',
  },
  notAble: {
    message: 'We have not been able to verify',
    iconName: 'WarningCircle',
    iconColor: 'warning400',
    backgroundColor: 'warning100',
    weight: 'light',
    size: '48',
  },
};

export const filesOptionMenuInfo: { [key in string]: FilesOptionListInfo } = {
  video: {
    menuTitle: 'Videos',
    menuIcon: 'CaretDown',
    menuIconLeft: 'VideoCamera',
    assetName: 'Video recording',
    assetIcon: 'Play',
  },
  audio: {
    menuTitle: 'Audios',
    menuIcon: 'CaretDown',
    menuIconLeft: 'Microphone',
    assetName: 'Audio recording',
    assetIcon: 'Play',
  },
  image: {
    menuTitle: 'Document',
    menuIcon: 'CaretDown',
    menuIconLeft: 'IdentificationCard',
    assetName: 'Document',
    assetIcon: 'MagnifyingGlassPlus',
  },
  photo: {
    menuTitle: 'Photo',
    menuIcon: 'CaretDown',
    menuIconLeft: 'UserFocus',
    assetName: 'Photo',
    assetIcon: 'MagnifyingGlassPlus',
  },
  fingerprint: {
    menuTitle: 'Fingerprint',
    menuIcon: 'CaretDown',
    menuIconLeft: 'FingerprintSimple',
    assetName: 'Fingerprint',
    assetIcon: 'MagnifyingGlassPlus',
  },
  signature: {
    menuTitle: 'Signature',
    menuIcon: 'CaretDown',
    menuIconLeft: 'Pen',
    assetName: 'Signature',
    assetIcon: 'MagnifyingGlassPlus',
  },
  uploader: {
    menuTitle: 'Uploaded',
    menuIcon: 'CaretDown',
    menuIconLeft: 'FilePlus',
    assetName: 'Uploader',
    assetIcon: 'MagnifyingGlassPlus',
  },
};

export const imageTypes = [
  'image',
  'photo',
  'fingerprint',
  'signature',
  'uploader',
];

export const infoNationality: { [key in string]: tInfo } = {
  match: {
    message: 'Nationality and geolocalization match',
    iconName: 'Check',
    iconColor: 'success400',
    backgroundColor: 'success100',
    weight: 'fill',
    size: '48',
  },
  notMatch: {
    message: `Nationality and geolocalization don't match`,
    iconName: 'X',
    iconColor: 'error400',
    backgroundColor: 'error100',
    weight: 'fill',
    size: '48',
  },
};
